import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'blank',
  standalone: false
})
export class BlankPipe implements PipeTransform {
  public readonly blank = '----';

  public transform(value: any): string {
    if (typeof value === 'undefined' || value === null) {
      return this.blank;
    }
    return value.toString();
  }

}
